'use strict';

module.exports = /*@ngInject*/
function(
    _,
    AnthroConfig,
    ReduxService
) {
    const getRegions = (state, countryCode = 'US') => {
        const siteConfig = _.find(state.core.siteConfig.sites, (s) => s.siteId === AnthroConfig.siteId);
        const countriesConfig = _.find(siteConfig.countries, (c) => c.countryCode.toLowerCase() === countryCode.toLowerCase());
        return countriesConfig ? countriesConfig.regions : [];
    };

    return {
        getCountries() {},

        getRegions(isRegistry, requestType) {
            return ReduxService.getState()
                .then((state) => {
                    let countryCode
                    if (isRegistry) {
                        countryCode = 'US';
                    } else {
                        countryCode = state.core.profile.site || 'US';
                    }
                    const regions = getRegions(state, countryCode);
                    return requestType === 'full' ? regions : regions.map((r) => r.regionCode);
                });
        }
    };
};
